import { __awaiter, __extends, __generator } from "tslib";
import React from 'react';
import { app as api } from '@ekuaibao/whispered';
var EditScenesProvider = (function (_super) {
    __extends(EditScenesProvider, _super);
    function EditScenesProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleEditScenes = function (activeSceneIndex) { return __awaiter(_this, void 0, void 0, function () {
            var _a, scenes, columns, prefixColumns, bus, resource, scenesType, _b, noType, _c, params, columnsList, isGroup, useNewFieldSet, blacklist, list, stackerOptions, data, filter, res;
            var _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this.props, scenes = _a.scenes, columns = _a.columns, prefixColumns = _a.prefixColumns, bus = _a.bus, resource = _a.resource, scenesType = _a.scenesType, _b = _a.noType, noType = _b === void 0 ? false : _b, _c = _a.params, params = _c === void 0 ? { id: '' } : _c, columnsList = _a.columnsList, isGroup = _a.isGroup, useNewFieldSet = _a.useNewFieldSet;
                        blacklist = ['waitInvoice'];
                        list = scenes.filter(function (s) { return !~blacklist.indexOf(s.scene); });
                        stackerOptions = {
                            viewKey: 'EditScenesView',
                            scenes: list,
                            columns: columns,
                            prefixColumns: prefixColumns,
                            switcherDataIndexes: this.getDefaultVisibleColumns(activeSceneIndex),
                            noType: noType,
                            columnsList: columnsList,
                            isGroup: isGroup,
                            useNewFieldSet: useNewFieldSet
                        };
                        return [4, api.open('@layout:ScenesStackerModal', stackerOptions)];
                    case 1:
                        data = _e.sent();
                        filter = data.scenes.map(function (scene) { return JSON.stringify(scene); });
                        return [4, resource.POST('/$type', {
                                type: "" + scenesType + (params.id || ''),
                                filter: filter,
                                pageSize: ((_d = scenes[0]) === null || _d === void 0 ? void 0 : _d.pageSize) || 20
                            }, null)];
                    case 2:
                        res = _e.sent();
                        bus.emit('initScenes:action', res.value, scenesType);
                        return [2];
                }
            });
        }); };
        return _this;
    }
    EditScenesProvider.prototype.render = function () {
        return this.props.children({
            onEditScenes: this.handleEditScenes
        });
    };
    EditScenesProvider.prototype.getDefaultVisibleColumns = function (activeSceneIndex) {
        var scenes = this.props.scenes;
        var activeScene = scenes.find(function (scene) { return scene.active; }) || scenes.find(function (scene) { return scene.sceneIndex === activeSceneIndex; });
        return (activeScene === null || activeScene === void 0 ? void 0 : activeScene.defaultColumns) || [];
    };
    return EditScenesProvider;
}(React.PureComponent));
export { EditScenesProvider };
